<template lang="html">
  <div class="header flex-box">
      <div class="left-header">
        <a href="https://symbium.com">
          <img class="dashboard-logo" :src="`${assetsImagePath}/Symbium.svg`">
        </a>
        <div class="desktop-only">
          <button id="menu-icon" class="btn btn-login-success" @click="show = !show">
            <span class="account-initials">{{userInitialLetter}}</span>
          </button>
          <div class="background-click" @click="show = false" v-if="show">
            <div class="menu-dropdown">
              <div class="menu-section" v-for="link in links" :key="link.text" v-show="link.href">
                <a
                  @click="redirect(link.href)"
                  :class="['link-gray', 'body-14', selectedClass(link)]"
                >{{link.text }}</a>
              </div>
              <div class="menu-section sign-out">
                <div class='link-gray body-14' @click="logout">Sign Out</div>
              </div>
            </div>
          </div>
        </div>

        <div @click="expand = !expand" class="mobile-only cursor-pointer menu-controll">
          <span></span>
        </div>

        <transition name="slide">
          <div class="expanded-menu mobile-only" v-show="expand">
            <div class="background-click" @click="clickBackground">
              <div class="expanded-menu-container">
                <div class="menu-section menu-header">
                  <span class="name">Hi {{firstName}}!</span>
                  <div @click="expand = !expand" class="cursor-pointer menu-controll expand">
                    <span></span>
                  </div>
                </div>
                <div class="menu-body">
                  <div :class="['menu-section', link.desktopOnly && 'desktop-only']" v-for="link in links" :key="link.text">
                    <a @click="clickMenuOption(link)" :class="[
                      'menu-link', 
                      isCurrentMenu(link) && 'menu-group expanded', 
                      selectedClass(link)
                    ]">
                      <span class="link-gray body-14">{{link.text}}</span>
                      <i :class="['si-icon', 'purple', link.expand ? 'si-caret_up' : 'si-caret_down']" v-if="link.menu"></i>
                    </a>
                    <transition name="fade">
                      <Menu :currentMenu="link.text" :subMenu="subMenu" className="sub-menu" v-show="showAccountMenu && link.expand" />
                    </transition>
                  </div>
                  <div class="menu-section sign-out">
                    <div class="menu-link" @click="logout"><span class='link-gray body-14'>Sign Out</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
  </div>
</template>

<script>
import EventBus from 'src/components/EventBus.js'
import Menu from './Menu.vue'

export default {
  props: ['currentMenu', 'subMenu'],
  components: { Menu },
  data() {
    return {
      userInitialLetter: '',
      firstName: '',
      expand: false,
      show: false,
      showAccountMenu: false,
      linkMenuClick: false,
      links: [
        { text: 'Account', menu: true, expand: this.subMenu },
        { text: 'Account Overview', href: '/dashboard/account_overview', desktopOnly: true },
        { text: 'Profile', href: '/dashboard/profile' },
        { text: 'Change Password', href: '/dashboard/change_password' },
        { text: 'Notifications', href: '/dashboard/notifications' },
      ]
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
  },
  methods: {
    clickBackground() {
      if (!this.linkMenuClick) {
        this.expand = false;
      }
    },
    clickMenuOption(link) {
      if (link.menu) {
        this.$set(link, 'expand', !link.expand);
        this.linkMenuClick = true;
      } else {
        this.redirect(link.href);
      }
    },
    isCurrentMenu(link) {
      return link.menu && link.text === this.currentMenu;
    },
    selectedClass(link) {
      return link.text == this.currentMenu || link.text == this.subMenu ? 'selected' : '';
    },
    assignUserData(data) {
      if (data.first_name) {
        this.userInitialLetter = data.full_name.split(" ").map(name => name[0]).join("").toUpperCase();
        this.firstName = data.first_name
      }
      this.showAccountMenu = data.is_super_admin || data.is_vendor || data.ownerships.length > 0
      if (!this.showAccountMenu) {
        this.links.splice(0, 1)
        this.$set(this.links[0], 'desktopOnly', false)
      }
    },
    logout() {
      this.$user.logout();
      this.$router.push('/dashboard/login');
    },
    redirect(link) {
      this.$router.push(link);
    }
  }
}
</script>

<style lang="scss" scoped>

.header {
  height: 88px;
  background: white;
  align-items: center;
  padding: 24px;

  .dashboard-logo {
    width: 112px;
  }

  .btn-login-success {
    box-shadow: none;
    height: 40px;
    right: calc(50vw - calc(min(600px, 50vw)) + 24px);
  }

  .left-header {
    flex-grow: 1;
  }

  #menu-icon {
    background: var(--gradient-01);
    .account-initials {
      font-size: 14px;
      background: unset;
      color: var(--white);
      -webkit-background-clip: unset;
      -webkit-text-fill-color: unset
    }
  }

  .header-container {
    width: 100%;
    padding: 0 4px;
    position: relative;
  }

  .link-gray {
    color: var(--gray);
    font-weight: 400;

    &:hover {
      text-decoration: none;
      font-weight: 500;
      color: var(--black);
    }

    &.selected {
      color: var(--black);
      font-weight: 500;
    }
  }

  .background-click {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .menu-dropdown {
    position: absolute;
    top: 70px;
    right: calc(50vw - calc(min(600px, 50vw)) + 24px);
    padding: 20px 24px;
    background: var(--white);
    border-radius: 16px;
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 188px;

    .menu-section {
      padding: 4px 0;
      width: 137px;

      &.sign-out {
        border-top: 1px solid var(--gray-divider);
        margin-top: 14px;
        padding-top: 14px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 64px;

    .dashboard-logo {
      width: 80px;
    }

    .header-container {
      width: 100%;
      height: 100%;
    }

    .left-header {
      .menu-controll.expand:before {
        transform: translateY(8px) rotate(135deg);
      }

      .menu-controll.expand:after {
        transform: rotate(-135deg);
      }

      .menu-controll.expand span {
        transform: scale(0);
      }

      .menu-controll:after,
      .menu-controll:before,
      .menu-controll span {
        background-color: var(--black);
        content: '';
        display: block;
        height: 2px;
        margin: 2px 0;
      }

      .menu-controll {
        position: absolute;
        right: 24px;
        top: 24px;
        width: 16px;
      }
    }

    .expanded-menu {
      position: fixed;
      box-sizing: border-box;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180.25deg, #7E4A93 0.4%, #BE5A99 53.51%, #FF6D6D 102.37%);
      z-index: 999;
      opacity: 1;

      .background-click {
        width: 100%;
        height: 100%;
        position: relative;
      }

      .expanded-menu-container {
        background-color: white;
        width: calc(100% - 92px);
        height: 100vh;
        position: absolute;
        right: 0;
        max-width: 320px;

        .menu-controll {
          top: 20px;
          right: 24px;
        }

        .menu-body {
          height: calc(100% - 65px);
          overflow-y: scroll;
        }

        .menu-section {
          padding: 24px;
          
          min-height: 16px;
          font-size: 14px;
          line-height: 16px;
          text-align: left;
          box-sizing: content-box;

          .link-gray {
            color: var(--black);
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            letter-spacing: 0.07px;
          }

          .menu-link {
            margin: 0;
            padding: 24px 0 0;
            color: var(--purple);

            &:hover, &.selected {
              text-decoration: underline;
            }
          }

          &.menu-header {
            border-bottom: 1px solid var(--gray-divider);
            padding: 24px;
          }

          &.sign-out {
            border-top: 1px solid var(--gray-divider);
            padding-top: 0;
          }
        }

        .menu-group {
          color: var(--purple);

          &:hover, &.expanded {
            text-decoration: underline;
          }
        }

        .si-icon {
          display: inline-block;
          margin-left: 4px;
          vertical-align: middle;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
  }
}

.slide-leave-active, .slide-enter-active {
  transition: 0.5s;
  min-height: 100vh;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}
</style>
